// src/client/components/ProtectedRoute.tsx
//
// Phase B T2c: protected route wrapper.
//  - isInitializing 中: loading 表示 (boot fetch 完了まで判定保留)
//  - isAuthenticated false: /login へ redirect (元の path を state.from に保存、Phase B+ で post-login redirect に活用)
//  - isAuthenticated true: <Outlet /> で子 route 表示
//
// 参照:
//  - docs/plans/phase-b-frontend-mvp-plan.md (T2c)
//  - docs/architecture/permission-matrix.md (auth gate の上位概念)

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../providers/AuthProvider";

export function ProtectedRoute(): JSX.Element {
  const { t } = useTranslation();
  const { isAuthenticated, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) {
    return (
      <section className="mx-auto w-full max-w-3xl px-4 py-8">
        <p className="text-sm text-muted-foreground">{t("common.loading")}</p>
      </section>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
